function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSearchFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.104 13.078c0-6.061 4.913-10.974 10.973-10.974 6.06 0 10.974 4.913 10.974 10.974 0 6.06-4.913 10.973-10.974 10.973-6.06 0-10.973-4.913-10.973-10.973zm10.973-8.464c-4.667 0-8.463 3.797-8.463 8.464 0 4.665 3.796 8.463 8.463 8.463 4.666 0 8.463-3.798 8.463-8.463 0-4.667-3.797-8.464-8.463-8.464zm9.568 16.256L30 28.224 28.225 30l-7.355-7.355.232-.199c.482-.413.93-.862 1.344-1.344l.199-.232z",
    fill: props.color
  }));
}

export default SvgIconSearchFilled;